import { ReportMetric } from '@mnd-frontend/graphql-schema';
import type {
  Report2PerceptionBenchmarkSectionFragment,
  Report2VisibilityBenchmarkSectionFragment,
} from '../../generated/types';

export const awarenessMetrics = [
  ReportMetric.Mentions,
  ReportMetric.EstimatedTotalReach,
  ReportMetric.EstimatedReach,
  ReportMetric.EstimatedSocialMediaReach,
  ReportMetric.PrValue,
] as const;

export const brandReportMetrics = [...awarenessMetrics] as const;

const dummyBrandNames = ['__My Brand', 'Competitor 1', 'Competitor 2', 'Competitor 3'];
export const dummySectionVisibilityBenchmarkingId = 'dummySectionVisibilityBenchmarkingId';
export const dummySectionVisibilityBenchmarking = Object.freeze({
  __typename: 'ReportVisibilityBenchmarkSection',
  id: dummySectionVisibilityBenchmarkingId,
  title: null,
  description: null,
  state: 'DONE',
  subSections: [
    {
      __typename: 'ReportVisibilityBenchmarkShareOfVoice',
      id: 'dummySectionVisibilityBenchmarkingShareOfVoiceId',
      state: 'DONE',
      reportMetrics: {
        __typename: 'ReportVisibilityReportMetrics',
        brandName: dummyBrandNames[0],
        mentions: 591,
        hitIds: ['1', '2', '3'],
        share: 43,
        trendPercentage: 0.5,
      },
      competitorMetrics: [
        {
          __typename: 'ReportVisibilityCompetitorMetrics',
          searchProfileId: '10213487',
          brandName: dummyBrandNames[1],
          mentions: 412,
          share: 30,
          hitIds: ['4', '5', '6'],
          trendPercentage: -7,
        },
        {
          __typename: 'ReportVisibilityCompetitorMetrics',
          searchProfileId: '10213487',
          brandName: dummyBrandNames[2],
          mentions: 206,
          share: 15,
          hitIds: ['7', '8', '9'],
          trendPercentage: 2,
        },
        {
          __typename: 'ReportVisibilityCompetitorMetrics',
          searchProfileId: '10213487',
          brandName: dummyBrandNames[3],
          mentions: 165,
          share: 12,
          hitIds: ['10', '11', '12'],
          trendPercentage: -2,
        },
      ],
      insights2: [
        {
          __typename: 'ReportInsight',
          id: '1120',
          title: 'Insight 1',
          insight: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
          insightType: 'VisibilityBenchmarkShareOfVoice',
        },
        {
          __typename: 'ReportInsight',
          id: '1121',
          title: 'Insight 2',
          insight:
            'Nullam ac nibh sed orci condimentum sagittis in eget massa. Quisque urna nibh, hendrerit non tincidunt nec, rhoncus nec tortor.',
          insightType: 'VisibilityBenchmarkShareOfVoice',
        },
        {
          __typename: 'ReportInsight',
          id: '1122',
          title: 'Insight 3',
          insight:
            'Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Etiam sit amet sem eu arcu ultricies volutpat.',
          insightType: 'VisibilityBenchmarkShareOfVoice',
        },
      ],
    },
    {
      __typename: 'ReportVisibilityBenchmarkShareOfVoiceOverTime',
      id: 'dummySectionVisibilityBenchmarkShareOfVoiceOverTimeId',
      state: 'DONE',
      groupBy: 'QUARTER',
      metrics: Array(6 * 4)
        .fill({
          __typename: 'ReportVisibilityShareOfVoiceOverTimeMetrics',
          startAt: '2024-01-01',
          endAt: '2024-01-2',
          month: 1,
          week: null,
          mentions: 82,
          name: '',
          searchProfileIds: ['10212864'],
        })
        .map((m, index) => ({
          ...m,
          startAt: m.startAt.replace(
            /-\d\d-/,
            `-${((index % 6) + 1).toString().padStart(2, '0')}-`,
          ),
          endAt: m.endAt.replace(/-\d\d-/, `-${((index % 6) + 1).toString().padStart(2, '0')}-`),
          month: (index % 6) + 1,
          mentions: Math.floor(Math.random() * 100),
          name: dummyBrandNames[Math.floor(index / 6)],
        })),
      insights2: [
        {
          __typename: 'ReportInsight',
          id: '1114',
          title: 'Insight 1',
          insight:
            'Aenean id cursus ante, eget eleifend tortor. Cras consequat dolor ut purus tincidunt lobortis. Duis lorem orci, scelerisque ut justo nec, ultricies tempus tortor. Sed accumsan mi in neque dignissim tristique.',
          insightType: 'VisibilityBenchmarkShareOfVoiceOverTime',
        },
        {
          __typename: 'ReportInsight',
          id: '1115',
          title: 'Insight 2',
          insight:
            'Morbi malesuada aliquam nibh. Aliquam neque tortor, semper ac ipsum sit amet, ornare scelerisque neque.',
          insightType: 'VisibilityBenchmarkShareOfVoiceOverTime',
        },
        {
          __typename: 'ReportInsight',
          id: '1116',
          title: 'Insight 3',
          insight:
            'Sed in turpis sed massa vehicula pellentesque ac quis odio. Praesent quis enim molestie, hendrerit dui ac, congue ipsum.',
          insightType: 'VisibilityBenchmarkShareOfVoiceOverTime',
        },
      ],
    },
    {
      __typename: 'ReportSectionInsights',
      id: 'dummySectionVisibilityBenchmarkInsightsId',
      state: 'DONE',
      insights2: [
        {
          __typename: 'ReportInsight',
          id: '1128',
          insight:
            'Nam ultrices, urna non interdum bibendum, lectus urna pellentesque urna, sed auctor velit arcu convallis ipsum. Pellentesque pharetra scelerisque blandit. Aenean non posuere tellus. Etiam euismod, nisl vel elementum ornare, risus turpis rhoncus dui, a dapibus augue mauris non libero.',
          insightType: 'VisibilityBenchmarkSimilaritiesInsight',
        },
        {
          __typename: 'ReportInsight',
          id: '1129',
          insight:
            'Phasellus mattis orci eget ipsum malesuada, sed fermentum nulla aliquam. Nam suscipit blandit arcu in elementum. Morbi quis vestibulum metus, in accumsan sapien. Nam posuere ornare arcu, ut facilisis enim feugiat sed. Praesent tincidunt ipsum id efficitur efficitur. Nam quis ipsum quis dolor faucibus congue ac eget nisl.',
          insightType: 'VisibilityBenchmarkDifferencesInsight',
        },
      ],
    },
  ],
}) as Report2VisibilityBenchmarkSectionFragment & {
  title: string | null;
  description: string | null;
};

export const dummySectionPerceptionBenchmarkingId = 'dummySectionPerceptionBenchmarking';
export const dummySectionPerceptionBenchmarking = Object.freeze({
  __typename: 'ReportPerceptionBenchmarkSection',
  id: dummySectionPerceptionBenchmarkingId,
  title: null,
  description: null,
  state: 'DONE',
  subSections: [
    {
      __typename: 'ReportPerceptionBenchmarkSentimentOverview',
      id: '2730',
      state: 'DONE',
      metrics: [
        {
          __typename: 'PerceptionBenchmarkSentimentMetrics',
          brand: dummyBrandNames[0],
          searchProfileIds: [],
          sentiment: {
            __typename: 'BenchmarkSentiment',
            positiveSentimentPercent: 77.7,
            negativeSentimentPercent: 1.1,
            neutralSentimentPercent: 21.3,
          },
        },
        {
          __typename: 'PerceptionBenchmarkSentimentMetrics',
          brand: dummyBrandNames[1],
          searchProfileIds: [],
          sentiment: {
            __typename: 'BenchmarkSentiment',
            positiveSentimentPercent: 85.7,
            negativeSentimentPercent: 2.4,
            neutralSentimentPercent: 11.9,
          },
        },
        {
          __typename: 'PerceptionBenchmarkSentimentMetrics',
          brand: dummyBrandNames[2],
          searchProfileIds: [],
          sentiment: {
            __typename: 'BenchmarkSentiment',
            positiveSentimentPercent: 31.6,
            negativeSentimentPercent: 2.6,
            neutralSentimentPercent: 65.8,
          },
        },
        {
          __typename: 'PerceptionBenchmarkSentimentMetrics',
          brand: dummyBrandNames[3],
          searchProfileIds: [],
          sentiment: {
            __typename: 'BenchmarkSentiment',
            positiveSentimentPercent: 25.8,
            negativeSentimentPercent: 1.6,
            neutralSentimentPercent: 72.6,
          },
        },
      ],
      insights2: [
        {
          __typename: 'ReportInsight',
          id: '1097',
          title: 'Insight 1',
          insight:
            'Curabitur sollicitudin lacus dui, eu rhoncus tortor fringilla quis. Nam et luctus lacus. Nam rhoncus quam quis lacus rhoncus, vitae sagittis nibh feugiat. ',
          insightType: 'PerceptionBenchmarkSentimentOverview',
        },
        {
          __typename: 'ReportInsight',
          id: '1098',
          title: 'Insight 2',
          insight:
            'Donec vel tempor est. Donec porta dictum nisi, sit amet cursus mi feugiat quis. Vivamus interdum elit sed enim finibus condimentum.',
          insightType: 'PerceptionBenchmarkSentimentOverview',
        },
        {
          __typename: 'ReportInsight',
          id: '1099',
          title: 'Insight 3',
          insight:
            'Morbi fringilla lectus nec orci auctor, vitae consectetur erat dignissim. Donec accumsan vestibulum luctus.',
          insightType: 'PerceptionBenchmarkSentimentOverview',
        },
      ],
    },
    {
      __typename: 'ReportSectionInsights',
      id: '2731',
      state: 'DONE',
      insights2: [
        {
          __typename: 'ReportInsight',
          id: '1109',
          insight:
            'Vivamus ornare pellentesque quam, id sodales nisi tempus sed. Nunc a urna arcu. Morbi ac libero enim. Mauris arcu urna, tincidunt eu varius et, volutpat ut tortor. Praesent varius mauris est, ut iaculis lorem rutrum id. Morbi accumsan nisi vel nisi sollicitudin vestibulum. Nam vulputate ut diam et pretium.',
          insightType: 'PerceptionBenchmarkPositiveInsight',
        },
        {
          __typename: 'ReportInsight',
          id: '1110',
          insight:
            'Proin risus neque, suscipit eget purus ut, pretium varius neque. Integer pulvinar libero libero, eu condimentum lacus fringilla in. Quisque sed malesuada sem, ac auctor orci. Ut et finibus sapien, non faucibus nulla. Donec fermentum vestibulum fermentum.',
          insightType: 'PerceptionBenchmarkNegativeInsight',
        },
        {
          __typename: 'ReportInsight',
          id: '1111',
          insight:
            'Duis placerat dolor at erat mollis pulvinar. Phasellus tempus, ex at congue ultricies, risus tellus pellentesque est, at semper justo lectus eget dui. Mauris semper mauris non justo suscipit faucibus. Duis facilisis leo quis mauris rutrum viverra. Praesent pulvinar felis ut mattis bibendum. Ut id volutpat nulla. Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
          insightType: 'PerceptionBenchmarkNeutralInsight',
        },
      ],
    },
  ],
}) as Report2PerceptionBenchmarkSectionFragment & {
  title: string | null;
  description: string | null;
};
